import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LogoutModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  hideDialog(result = false) {
    this.activeModal.close(result);
    return false;
  }

  @HostListener('keydown', ['$event'])
  // Not private: Angular 21 host bindings access the listener from outside the class.
  onKeyup(e): void {
    if (e.key === 'Enter') {
      this.hideDialog(true);
    }
  }
}
